<template>
  <panel v-if="selectedOffice.network_id === 2 && !this.selectedOffice.focal_agent_active" class="pt-6">
    <div>
      <i class="fas fa-exclamation-triangle mr-2"></i> Awaiting Focal Agent branch activation. Please check back later.
    </div>
  </panel>

  <panel v-else-if="selectedOffice.network_id === 2 && !this.selectedOffice.permissions.includes('access digital hub')" class="pt-6">
    <div>
      <i class="fas fa-exclamation-triangle mr-2"></i> Digital Hub access is required in order to create a marketing pack order.
    </div>
  </panel>

  <panel v-else class="pt-6">
    <h2 class="text-center mb-3">{{ page.product_config.heading }}</h2>
    <p class="text-center text-grey-darker">{{ page.product_config.intro }}</p>

    <div v-if="foundation_donation" class="flex justify-center">
      <div class="w-full md:w-1/2 bg-grey-lightest border p-3 mt-6 text-grey-darker">
        <div class="flex items-center -mx-3">
          <div class="w-1/3 px-3">
            <img src="/img/fc_foundation_black.png" alt="Fine & Country Foundation" class="block" />
          </div>
          <div class="w-2/3 px-3">
            For each pack ordered, <strong class="text-black">{{ foundation_donation | gbp }}</strong> is donated to the Fine & Country Foundation.
          </div>
        </div>
      </div>
    </div>

    <div class="flex flex-wrap justify-center -mx-3 mt-6">
      <div v-for="pack in packs" :key="pack.id" class="w-full md:w-1/4 px-3">
        <div class="bg-white border text-center h-full shadow-md hover:shadow-lg hover:bg-grey-lighter transition cursor-pointer flex flex-col" @click="selectPack(pack)">
          <div class="flex-grow p-3">
            <h3>{{ pack.name }}</h3>
            <p class="text-sm">{{ pack.delivery_print && pack.delivery_digital ? 'Print & Digital Delivery' : (pack.delivery_print ? 'Print Delivery' : 'Digital Delivery') }}</p>
            <hr class="border-secondary border-b w-1/4" />

            <div v-if="pack.price_print === pack.price_digital || pack.price_print === null || pack.price_digital === null">
              <strong>{{ pack.price_print === null ? pack.price_digital : pack.price_print | gbp }}</strong>&nbsp;<small class="text-grey text-xxs">+VAT</small>
            </div>
            <div v-else>
              <div v-if="pack.delivery_print">
                <strong>{{ pack.price_print | gbp }}</strong>&nbsp;<small class="text-grey text-xxs">+VAT</small>
                <span class="text-sm" v-if="pack.delivery_digital"> - Print Delivery</span>
              </div>
              <div v-if="pack.delivery_digital">
                <strong>{{ pack.price_digital | gbp}}</strong>&nbsp;<small class="text-grey text-xxs">+VAT</small>
                <span class="text-sm" v-if="pack.delivery_print"> - Digital Delivery</span>
              </div>
            </div>

            <hr class="border-b" />

            <p class="text-xs text-grey-darker">{{ pack.description }}</p>
          </div>

          <div class="bg-primary text-white p-3 uppercase mt-3 text-sm">
            Select
          </div>
        </div>
      </div>
    </div>
  </panel>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: ['page', 'packs', 'foundation_donation'],
  computed: {
    ...mapState(['selectedOffice'])
  },
  methods: {
    selectPack (pack) {
      this.$emit('start', pack.id)
    }
  }
}
</script>
